import styled from 'styled-components';
import { textStyleCss } from 'src/theme/atlas';

export const CategoryPropertyStyled = styled.div`
  width: 100%;
  flex-direction: column;
`;

export const CategoryPropertyHeader = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CategoryPropertyTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const CategoryPropertyHeaderText = styled.p<{ disabled?: boolean }>`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.body)}
  font-weight: 600;
  color: ${(props) =>
    props.disabled
      ? props.theme.atlas.semantic.color.type.muted
      : props.theme.atlas.semantic.color.type.default};
  margin: 8px 0;
`;

export const CategoryPropertyDescriptionText = styled.p`
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.caption)}
  color: ${(props) => props.theme.atlas.semantic.color.type.muted};
  margin-top: 0;
`;
